import React from 'react';
import Block from '~/components/ui/block/Block';
import { styled } from "styled-components";
import Button from '~/components/ui/button/Button';
import Alert from '~/components/ui/alert/alert';

const Wrapper = styled.div`
  .wz_header {
    height: 130px;
    display: flex;
  }
  
  .wz_header h1 {
    color: #000;
    font-family: Recoleta;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  
    display: flex;
    flex: 1
  }
  
  .wz_header .wz_cont {
    padding-right: 40px !important;
  }
  
  .wz_progress {
    display: flex;
    flex-direction: row;
    right: 0;
    margin-left: auto;
    // padding-top: 5px;
    padding-right: 20px;
  }
  
  .wz_progress .wz_step {
    border-top: 2px solid #E0E0E0;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 5px;
    // width: 110px;
    width: 124px;
  }
  
  .wz_progress .div_wz_line {
    border-top: 2px solid #9738FF !important;
    margin-top: -7px;
    position: absolute;
    z-index: 100;
    width: 140px;
  }
  
  .wz_progress .div_wz_halfline {
    border-top: 2px solid #9738FF !important;
    margin-top: -7px;
    position: absolute;
    z-index: 100;
    width: 60px;
  }
  
  .wz_progress .wz_step.wz_active .wz_dot {
    background-color: #9738FF;
  }
  
  .wz_progress .wz_step strong {
    color: var(--Black-00, #000);
    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    width: 100%;
    display: block;
  }
  
  .wz_progress .wz_step:first-of-type {
    padding-left: 0px;
  }
  
  .wz_progress .wz_step:first-of-type strong {
    text-align: left;
  }
  
  .wz_progress .wz_step:first-of-type p {
    text-align: left;
  }

  .wz_progress .wz_step:last-of-type {
    padding-right: 0px;
  }
  
  .wz_progress .wz_step:last-of-type strong {
    text-align: right;
  }
  
  .wz_progress .wz_step:last-of-type p {
    text-align: right;
  }
  
  .wz_progress .wz_step p {
    color: var(--Grey-6F, #6F6F6F);
    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
  
    
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .wz_progress .wz_step .wz_dot {
    margin-top: -12px;
    width: 12px;
    height: 12px;
    display: block;
    background-color: #E0E0E0;
    border-radius: 6px;
    margin-left: calc(50% - 6px);
  }
  
  .wz_progress .wz_step:first-of-type .wz_dot {
    margin-left: 0px;
  }
  
  .wz_progress .wz_step:last-of-type .wz_dot {
    margin-left: unset;
    left: calc(100% - 12px);
    position: relative;
  }
  
  .wz_progress .wz_step:last-of-type .div_wz_line {
    width: 110px;
  }
`;

function decodeHtmlEntities(text) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

const Header = ({ activeStep, title, companyId, trainingId, dataWasSaved }) => {
  const steps = [];
  steps.push({ step: 1, title: 'Instructions' });
  steps.push({ step: 2, title: 'Create your course' });
  steps.push({ step: 3, title: 'Customizations' });
  steps.push({ step: 4, title: 'Review & Publish' });

  const onExit = () => {
    window.location.href = `/companies/${companyId}/trainings/${trainingId}`;
  };

  return (
    <Wrapper>
      {dataWasSaved && <Alert text='Data has been successfully updated' />}
      <Block classname='wz_header' style={{width: 'unset'}}>
          <h1>{title ? `Edit "${decodeHtmlEntities(title)}"` : `Create a custom Course`}</h1>
          <div className='wz_progress'>
            {steps.map((el, i) => {
              return (
                <div
                  key={`step_${i}`}
                  className={`wz_step ${el.step <= activeStep ? 'wz_active' : ''}`}
                >
                  {(el.step < activeStep || activeStep === steps.length) ? (<div className='div_wz_line'></div>) : false}
                  {(el.step <= activeStep && activeStep > 1) ? (<div className='div_wz_halfline'></div>) : false}
                  <i className='wz_dot'></i>
                  <strong>Step {el.step}</strong>
                  <p>{el.title}</p>
                </div>
              );
            })}
          </div>
          {companyId && <Button title='Exit' onClick={onExit} />}
      </Block>
    </Wrapper>
  );
}

export default Header;
